/* eslint-disable prettier/prettier */
import React, { ReactNode } from "react";
import { AuthProvider as OidcAuthProvider } from "react-oidc-context";
import { createOidcConfig } from "./OidcConfig";

interface OidcProviderProps {
  children: ReactNode;
}

export const OidcProvider: React.FC<OidcProviderProps> = ({ children }) => {
  const oidcConfig = createOidcConfig();

  return (
    <OidcAuthProvider {...oidcConfig}>
      {children}
    </OidcAuthProvider>
  );
};

export default OidcProvider;